import { createApiSaga } from '../../sagaGenerator';
import { apiGet } from '../../../middleware/api';
import {
  EARTHQUAKE_SEARCH_REQUEST,
  EARTHQUAKE_SEARCH_SUCCESS,
  EARTHQUAKE_SEARCH_FAILURE,
  EARTHQUAKE_SEARCH_REGION_REQUEST,
  EARTHQUAKE_SEARCH_REGION_SUCCESS,
  EARTHQUAKE_SEARCH_REGION_FAILURE,
  EARTHQUAKE_SEARCH_COUNTRY_REQUEST,
  EARTHQUAKE_SEARCH_COUNTRY_SUCCESS,
  EARTHQUAKE_SEARCH_COUNTRY_FAILURE,
  EARTHQUAKE_SEARCH_AREA_REQUEST,
  EARTHQUAKE_SEARCH_AREA_SUCCESS,
  EARTHQUAKE_SEARCH_AREA_FAILURE,
} from './earthquakeSearchReducer';

const searchEarthquakesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/earthquakes', ...action }),
  requestType: EARTHQUAKE_SEARCH_REQUEST,
  successType: EARTHQUAKE_SEARCH_SUCCESS,
  failureType: EARTHQUAKE_SEARCH_FAILURE,
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/earthquake/regions', ...action }),
  requestType: EARTHQUAKE_SEARCH_REGION_REQUEST,
  successType: EARTHQUAKE_SEARCH_REGION_SUCCESS,
  failureType: EARTHQUAKE_SEARCH_REGION_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/earthquake/countries', ...action }),
  requestType: EARTHQUAKE_SEARCH_COUNTRY_REQUEST,
  successType: EARTHQUAKE_SEARCH_COUNTRY_SUCCESS,
  failureType: EARTHQUAKE_SEARCH_COUNTRY_FAILURE,
});

const getAreasSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/descriptors/earthquake/areas/${action.country}`, ...action }),
  requestType: EARTHQUAKE_SEARCH_AREA_REQUEST,
  successType: EARTHQUAKE_SEARCH_AREA_SUCCESS,
  failureType: EARTHQUAKE_SEARCH_AREA_FAILURE,
});

export const searchEarthquakesSagas = [
  searchEarthquakesSaga,
  getRegionsSaga,
  getCountriesSaga,
  getAreasSaga,
];
